import React from 'react';

import { Icon20ShoppingCartOutline } from '@vkontakte/icons';
import {
  Button,
  Spacing,
  Text,
} from '@vkontakte/vkui';
import { AnimatePresence, motion } from 'framer-motion';

import styles from './index.module.css';
import { PaymentProps } from './types';
import { IconedText } from '../../../../../../../components/IconedText';
import { FRIEND_PREDICTION_PRICE } from '../../../../../../../constants/Common';

export const Payment: React.FC<PaymentProps> = ({ handlePayButtonClick }) => {
  return (
    <div>
      <Text className={styles.invitationText}>
          Оплатите голосами и узнайте, что страницы людей говорят об их профессиональном типе
      </Text>
      <Spacing size={12} />
      <div className={styles.bottom}>
        <Button
          onClick={handlePayButtonClick}
          mode="primary"
          size="l"
        >
            Оплатить и узнать результаты
        </Button>
        <Spacing size={32} />
        <div className={styles.iconedTextContainer}>
          <IconedText
            icon={
              <AnimatePresence>
                <motion.div animate={{ x: [6, -4, 0] }} transition={{ duration: 0.3 }}>
                  <Icon20ShoppingCartOutline className={styles.icon}/>
                </motion.div>
              </AnimatePresence>
            }
            text={(
              <span className={styles.iconedText}>
                  Проверка другого человека становится доступна после оплаты {FRIEND_PREDICTION_PRICE} голоса. В случае ошибки оплата голосов не будет произведена
              </span>
            )}
          />
        </div>
      </div>
    </div>);
};
